import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'

const AdditionalInfoBody: React.FC = () => {
  const help = HelpMessage.CAS.SubmittalTracker
  return (
    <>
      <CIMSFormItem name="payItemIds" label="Pay Item(s)" help={help.PayItems}>
        <PayItemSelect mode="multiple" />
      </CIMSFormItem>
      <CustomFieldEditor alreadyDisabled={false} />
    </>
  )
}

export default AdditionalInfoBody
